import { object, string, number } from "yup";
import i18next from "/app/src/locales/config";

export const newOrderLineSchema = object().shape({
  materialId: string().required(i18next.t("translation:required")),
  quantity: number().required(i18next.t("translation:required")),
});
